const paddeeContainer = document.querySelector('#paddee-container');
const key = paddeeContainer && paddeeContainer.dataset.key;

if (!paddeeContainer || !key) {
  const message = `
  Paddee widget is not properly installed.
  
  Please ignore this message if you are a user. Try to use the app later.
  
  
  If you are a developer - please update widget code!
  `;
  alert(message);
}

export const companyId = (key || '_').split('_')[1];

const categoriesStr = paddeeContainer && paddeeContainer.dataset.categories;
export const categories = categoriesStr ? categoriesStr.split(',') : [];

const tagsStr = paddeeContainer && paddeeContainer.dataset.tags;
export const tags = tagsStr ? tagsStr.split(',') : [];

const message = `Paddee widget installed.
Categories:  ${categories}
Tags:  ${tags}
`;
console.log(message);



// WEBPACK FOOTER //
// ./src/utils/variables.js